<div class="drawer-container no-scrollbar">
	<!-- HEADER SECTION -->
	<header class="nav-header">
		<div class="user-info">
			<div class="user-details">
				<ion-icon name="person-circle-outline"></ion-icon>
				<span class="username">{{ helperService.getUsername() }}</span>
			</div>

			<ion-menu-toggle>
				<ion-button fill="clear">
					<ion-icon name="close-circle-outline" slot="icon-only"></ion-icon>
				</ion-button>
			</ion-menu-toggle>
		</div>

		<div class="balance-section">
			<span class="balance-label">{{ 'Balance' | translate }}</span>
			<span class="balance-amount">{{ showCurrency ? currency() : '' }} {{ balance() | number: '1.0-2' }}</span>
		</div>
	</header>

	<!-- SCROLLABLE MENU CONTENT -->
	<div class="nav-scroll-content no-scrollbar">
		<!-- ACCOUNT GROUP -->
		<div class="nav-group-label">{{ 'Account' | translate }}</div>

		<ion-menu-toggle appHideForDemoAccount class="nav-menu-item" (click)="goTo('my-profile')">
			<ion-icon name="person-outline"></ion-icon>
			<span class="item-text">{{ 'My Profile' | translate }}</span>
		</ion-menu-toggle>

		<ion-menu-toggle class="nav-menu-item" (click)="goTo('sports')">
			<ion-icon name="trophy-outline"></ion-icon>
			<span class="item-text">{{ 'Sports' | translate }}</span>
		</ion-menu-toggle>

		<ion-menu-toggle class="nav-menu-item" (click)="openWalletTransfer()">
			<ion-icon name="wallet-outline"></ion-icon>
			<span class="item-text">{{ 'Transfer Wallet' | translate }}</span>
		</ion-menu-toggle>

		<ion-menu-toggle appHideForDemoAccount class="nav-menu-item" (click)="goTo('change-password')">
			<ion-icon name="key-outline"></ion-icon>
			<span class="item-text">{{ 'Change Password' | translate }}</span>
		</ion-menu-toggle>

		<!-- REPORTS GROUP -->
		<div class="nav-group-label">{{ 'Reports' | translate }}</div>

		<ion-menu-toggle class="nav-menu-item" (click)="goTo('past-bets')">
			<ion-icon name="analytics"></ion-icon>
			<span class="item-text">{{ 'Past Bets' | translate }}</span>
		</ion-menu-toggle>

		<ion-menu-toggle class="nav-menu-item" (click)="goTo('account-statement')">
			<ion-icon name="document-text-outline"></ion-icon>
			<span class="item-text">{{ 'Account Statement' | translate }}</span>
		</ion-menu-toggle>

		<ion-menu-toggle class="nav-menu-item" (click)="goTo('profit-and-loss')">
			<ion-icon name="trending-up-outline"></ion-icon>
			<span class="item-text">{{ 'Profit & Loss' | translate }}</span>
		</ion-menu-toggle>

		<!-- PREFERENCES GROUP -->
		<div class="nav-group-label">{{ 'Preferences' | translate }}</div>

		<div class="nav-menu-item" (click)="toggleSettingsDropdown()">
			<ion-icon name="settings-outline"></ion-icon>
			<span class="item-text font-bold">{{ 'Settings' | translate }}</span>
			<ion-icon name="chevron-down-outline" class="chevron-icon" [ngClass]="{ rotated: showSettingsDropdown() }"></ion-icon>
		</div>

		@if (showSettingsDropdown()) {
			<div class="settings-submenu">
				<!-- Bet Slip Settings -->
				<div class="settings-sub-item" (click)="goTo('bet-slip-settings')">
					<div class="sub-item-header">
						<ion-icon name="construct-outline"></ion-icon>
						<span class="sub-item-text">{{ 'Bet Slip Settings' | translate }}</span>
						<ion-icon name="chevron-forward-outline" class="chevron-arrow"></ion-icon>
					</div>
				</div>

				<!-- Display Settings -->
				<div class="settings-sub-item">
					<div class="sub-item-header" (click)="selectDisplayMode(displayService.displayMode() === 'time' ? 'league' : 'time')">
						<ion-icon name="options-outline"></ion-icon>
						<span class="sub-item-text">{{ 'Display Mode' | translate }}</span>
						<div class="sub-item-action">
							<span>{{ displayService.displayMode() === 'time' ? 'TIME-WISE' : 'LEAGUE-WISE' }}</span>
							<ion-icon name="swap-horizontal-outline"></ion-icon>
						</div>
					</div>
				</div>

				<!-- Font Settings -->
				<div class="settings-sub-item">
					<div class="sub-item-header" (click)="toggleFontDropdown()">
						<ion-icon name="text-outline"></ion-icon>
						<span class="sub-item-text">{{ 'Font Size' | translate }}</span>
						<div class="sub-item-value">
							<span>{{ getSelectedFontSizeLabel() | translate }}</span>
							<ion-icon name="chevron-down-outline" class="chevron-arrow" [ngClass]="{ rotated: showFontDropdown() }"></ion-icon>
						</div>
					</div>

					@if (showFontDropdown()) {
						<div class="nested-expansion-list">
							@for (option of fontSizeService.fontSizeOptions; track option.key) {
								<div
									class="expansion-list-item"
									[ngClass]="{ active: fontSizeFormControl.value === option.key }"
									(click)="fontSizeFormControl.setValue(option.key)">
									<span>{{ option.label | translate }}</span>
									@if (fontSizeFormControl.value === option.key) {
										<ion-icon name="checkmark-outline"></ion-icon>
									}
								</div>
							}
						</div>
					}
				</div>

				<!-- Color Theme Settings -->
				@if (themeColorService.supportsColorTheme) {
					<div class="settings-sub-item">
						<div class="sub-item-header" (click)="toggleColorDropdown()">
							<ion-icon name="color-palette-outline"></ion-icon>
							<span class="sub-item-text">{{ 'Color Theme' | translate }}</span>
							<div class="sub-item-value">
								<div class="color-preview" [style.background-color]="getSelectedColorThemeColor()"></div>
								<span>{{ getSelectedColorThemeLabel() | translate }}</span>
								<ion-icon name="chevron-down-outline" class="chevron-arrow" [ngClass]="{ rotated: showColorDropdown() }"></ion-icon>
							</div>
						</div>

						@if (showColorDropdown()) {
							<div class="nested-expansion-list">
								@for (option of themeColorService.colorOptions; track option.key) {
									<div
										class="expansion-list-item"
										[ngClass]="{ active: colorThemeFormControl.value === option.key }"
										(click)="colorThemeFormControl.setValue(option.key)">
										<div class="color-option">
											<div class="color-preview" [style.background-color]="option.color"></div>
											<span>{{ option.label | translate }}</span>
										</div>
										@if (colorThemeFormControl.value === option.key) {
											<ion-icon name="checkmark-outline"></ion-icon>
										}
									</div>
								}
							</div>
						}
					</div>
				}

				<!-- Language Settings -->
				<div class="settings-sub-item">
					<div class="sub-item-header" (click)="toggleLanguageDropdown()">
						<ion-icon name="language-outline"></ion-icon>
						<span class="sub-item-text">{{ 'Language' | translate }}</span>
						<div class="sub-item-value">
							<span>{{ getSelectedLanguageName() | translate }}</span>
							<ion-icon name="chevron-down-outline" class="chevron-arrow" [ngClass]="{ rotated: showLanguageDropdown() }"></ion-icon>
						</div>
					</div>

					@if (showLanguageDropdown()) {
						<div class="nested-expansion-list">
							@for (language of SUPPORTED_LANGUAGES; track language.name) {
								<div
									class="expansion-list-item"
									[ngClass]="{ active: languageFormControl.value === language.symbol }"
									(click)="languageFormControl.setValue(language.symbol)">
									<span>{{ language.name | translate }}</span>
									@if (languageFormControl.value === language.symbol) {
										<ion-icon name="checkmark-outline"></ion-icon>
									}
								</div>
							}
						</div>
					}
					@if (isUpdatingLanguage()) {
						<div class="flex justify-center p-2">
							<ion-spinner size="small"></ion-spinner>
						</div>
					}
				</div>
			</div>
		}

		<!-- SUPPORT GROUP -->
		@if (supportChannelService.hasAny()) {
			<div class="nav-group-label">{{ 'Support' | translate }}</div>

			@if (supportChannelService.whatsapp(); as wa) {
				@if (wa.WEB_LINK) {
					<ion-menu-toggle>
						<a [href]="wa.WEB_LINK" target="_blank" rel="noopener noreferrer" class="nav-menu-item no-underline">
							<ion-icon name="logo-whatsapp" style="color: #25d366"></ion-icon>
							<span class="item-text">WhatsApp</span>
						</a>
					</ion-menu-toggle>
				}
			}

			@if (supportChannelService.telegram(); as tg) {
				@if (tg.WEB_LINK) {
					<ion-menu-toggle>
						<a [href]="tg.WEB_LINK" target="_blank" rel="noopener noreferrer" class="nav-menu-item no-underline">
							<ion-icon name="paper-plane-outline" style="color: #229ed9"></ion-icon>
							<span class="item-text">Telegram</span>
						</a>
					</ion-menu-toggle>
				}
			}
		}

		<ion-menu-toggle class="nav-menu-item" (click)="logOut()">
			<ion-icon name="log-out-outline"></ion-icon>
			<span class="item-text">{{ 'Logout' | translate }}</span>
		</ion-menu-toggle>

		<!-- FOOTER INFO -->
		<div class="footer-section">
			@if (showFeedbackButton) {
				<div class="report-bug-btn" (click)="goTo('report-bug')">
					<ion-icon name="bug-outline"></ion-icon>
					<span>{{ 'Report Bug' | translate }}</span>
				</div>
			}
			@if (!environment.production || environment.environment === 'DEV') {
				<p class="version-text">{{ 'Version' | translate }}: {{ getVersion() }}</p>
			}
		</div>
	</div>
</div>
